import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DispatcherCity, DispatcherScopeService } from "src/app/core/services/dispatcher-scope.service";

@Component({
  selector: "app-city-selector",
  templateUrl: "./city-selector.component.html",
  styleUrls: ["./city-selector.component.scss"],
  standalone: false
})
export class CitySelectorComponent implements OnInit, OnDestroy {
  cities: DispatcherCity[] = [];
  selectedId: string | null = null;
  private destroy$ = new Subject<void>();

  constructor(private scope: DispatcherScopeService) {}

  ngOnInit(): void {
    this.scope.cities$.pipe(takeUntil(this.destroy$)).subscribe((cs) => (this.cities = cs));
    this.scope.selectedCity$.pipe(takeUntil(this.destroy$)).subscribe((c) => (this.selectedId = c?._id ?? null));
  }

  onChange(id: string): void {
    if (id) this.scope.setCity(id);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
